import {
  useCallback,
  useEffect,
  useRef,
} from 'react';

import { FormTextarea } from '@/core/components/FormTextarea';

interface PersonalMessageTextareaProps {
  backgroundcolor: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
}

export const PersonalMessageTextarea = ({
  backgroundcolor,
  onChange,
  value,
}: PersonalMessageTextareaProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const adjustHeight = useCallback(() => {
    if (wrapperRef.current) {
      const textarea = wrapperRef.current.querySelector('textarea');

      if (textarea) {
        const minHeight = 100;
        const maxHeight = 200;

        textarea.style.height = 'auto';
        const newHeight = Math.max(minHeight, Math.min(textarea.scrollHeight, maxHeight));

        textarea.style.height = `${newHeight}px`;
      }
    }
  }, []);

  useEffect(() => {
    adjustHeight();
  }, [
    value,
    adjustHeight,
  ]);

  return (
    <div ref={wrapperRef}>
      <FormTextarea
        className="muster-personal-message"
        label="Personal message"
        backgroundcolor={backgroundcolor}
        onChange={onChange}
        overflow="auto"
        placeholder="Add a personal note to customize your message"
        value={value}
      />
    </div>
  );
};
